import React from "react";
import { GALLERY } from "../data/cruiseData";
import SEOHead from "../components/SEOHead";

export default function Gallery() {
 return (
 <main className="pt-32 pb-24" data-testid="gallery-page">
 <SEOHead
  title="Photo Gallery | Sydney Harbour Cruises on MV Sydney Magic | Magic Cruises"
  description="Photo gallery of Sydney Harbour cruises aboard MV Sydney Magic , weddings, corporate events, NYE fireworks, sunset cruises, birthdays and private charters captured from King St Wharf and out on the harbour."
  image={GALLERY[0]}
  canonical="/gallery"
  keywords="Sydney Harbour cruise photos, Magic Cruises gallery, wedding boat photos Sydney, NYE fireworks cruise photos"
  breadcrumbs={[
   { name: "Home", url: "/" },
   { name: "Gallery", url: "/gallery" },
  ]}
 />
 <div className="mx-auto max-w-7xl px-5 lg:px-10">
 <div className="eyebrow">The Gallery</div>
 <h1 className="font-display text-4xl lg:text-7xl mt-3 mb-10 text-ink leading-[1]">Moments on <span className="text-pink italic">Magic</span>.</h1>
 <div className="columns-2 lg:columns-3 gap-4 space-y-4">
 {GALLERY.map((g, i) => (
 <div key={i} className="plate break-inside-avoid card-pop"><img src={g} alt={`Sydney Harbour cruise on MV Sydney Magic , gallery photo ${i + 1}`} loading="lazy" className="w-full object-cover" /></div>
 ))}
 </div>
 </div>
 </main>
 );
}
